export default __webpack_public_path__ + "static/lsa-boss-91d6704a3e9d322bb7cd847d30d7db92.jpg";